export default "__VITE_ASSET__rVGBMDlw__"